"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zonedDateTimeFromDto = exports.zonedDateTimeToDto = exports.localDateTimeFromDto = exports.localDateTimeToDto = exports.localTimeFromDto = exports.localTimeToDto = exports.localDateFromDto = exports.localDateToDto = void 0;
const core_1 = require("@js-joda/core");
require("@js-joda/timezone");
// =============================================================================
// JS Joda transformers
// =============================================================================
function localDateToDto(value) {
    return value ? value.toString() : undefined;
}
exports.localDateToDto = localDateToDto;
function localDateFromDto(value) {
    return value ? core_1.LocalDate.parse(value) : undefined;
}
exports.localDateFromDto = localDateFromDto;
function localTimeToDto(value) {
    return value ? value.toString() : undefined;
}
exports.localTimeToDto = localTimeToDto;
function localTimeFromDto(value) {
    return value ? core_1.LocalTime.parse(value) : undefined;
}
exports.localTimeFromDto = localTimeFromDto;
function localDateTimeToDto(value) {
    return value ? value.toString() : undefined;
}
exports.localDateTimeToDto = localDateTimeToDto;
function localDateTimeFromDto(value) {
    return value ? core_1.LocalDateTime.parse(value) : undefined;
}
exports.localDateTimeFromDto = localDateTimeFromDto;
function zonedDateTimeToDto(value) {
    return value ? value.toString() : undefined;
}
exports.zonedDateTimeToDto = zonedDateTimeToDto;
function zonedDateTimeFromDto(value) {
    return value ? core_1.ZonedDateTime.parse(value) : undefined;
}
exports.zonedDateTimeFromDto = zonedDateTimeFromDto;
//# sourceMappingURL=date-transformers.js.map